import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { criarPedido, confirmarPagamento, getRoletaConfig, girarRoleta } from '../services/api';
import axios from 'axios';

const api = (url, opts = {}) => axios({ url, ...opts, headers: { ...opts.headers, Authorization: `Bearer ${localStorage.getItem('token')}` } });

// ==================== ROLETA ====================
function Roleta({ pedidoId, onFechar }) {
  const canvasRef = useRef();
  const [premios, setPremios] = useState([]);
  const [girando, setGirando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [copiado, setCopiado] = useState(false);
  const anguloRef = useRef(0);

  useEffect(() => { getRoletaConfig().then(r => setPremios(r.data.premios || [])); }, []);
  useEffect(() => { if (premios.length) desenhar(anguloRef.current); }, [premios]);

  const desenhar = (ang) => {
    const canvas = canvasRef.current; if (!canvas || !premios.length) return;
    const ctx = canvas.getContext('2d');
    const cx = 140, cy = 140, r = 134, slice = (Math.PI * 2) / premios.length;
    ctx.clearRect(0, 0, 280, 280);
    premios.forEach((p, i) => {
      const start = ang + i * slice, end = start + slice;
      ctx.beginPath(); ctx.moveTo(cx, cy); ctx.arc(cx, cy, r, start, end); ctx.closePath();
      ctx.fillStyle = p.cor || '#e63030'; ctx.fill();
      ctx.strokeStyle = '#0a0a0a'; ctx.lineWidth = 2; ctx.stroke();
      ctx.save(); ctx.translate(cx, cy); ctx.rotate(start + slice / 2);
      ctx.textAlign = 'right'; ctx.fillStyle = '#fff'; ctx.font = 'bold 11px Nunito,sans-serif';
      ctx.fillText(p.nome, r - 8, 4); ctx.restore();
    });
    ctx.beginPath(); ctx.arc(cx, cy, 20, 0, Math.PI * 2);
    ctx.fillStyle = '#0a0a0a'; ctx.fill(); ctx.strokeStyle = 'var(--orange)'; ctx.lineWidth = 3; ctx.stroke();
  };

  const girar = async () => {
    if (girando || !premios.length) return;
    setGirando(true);
    try {
      const r = await girarRoleta(pedidoId);
      const data = r.data;
      const indice = data.indice ?? 0;
      const slice = (Math.PI * 2) / premios.length;
      const centroFatia = indice * slice + slice / 2;
      const anguloAlvo = (-Math.PI / 2) - centroFatia;
      const voltasExtras = Math.PI * 2 * 5;
      const anguloAtualNorm = ((anguloRef.current % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);
      const alvoNorm = ((anguloAlvo % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);
      const diff = ((alvoNorm - anguloAtualNorm) + Math.PI * 2) % (Math.PI * 2);
      const totalRotacao = voltasExtras + diff;
      const dur = 4500, start = Date.now(), startAng = anguloRef.current;
      const anim = () => {
        const t = Math.min((Date.now() - start) / dur, 1);
        const ease = 1 - Math.pow(1 - t, 3);
        anguloRef.current = startAng + totalRotacao * ease;
        desenhar(anguloRef.current);
        if (t < 1) requestAnimationFrame(anim);
        else { setGirando(false); setResultado(data); }
      };
      requestAnimationFrame(anim);
    } catch (err) {
      setGirando(false);
      setResultado(null);
      alert('Erro ao girar a roleta. Tente novamente.');
    }
  };

  const validade = new Date(); validade.setDate(validade.getDate() + 7);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.95)', zIndex: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20, overflowY: 'auto' }}>
      <h1 style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 34, background: 'linear-gradient(90deg,var(--red),var(--orange))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 4, textAlign: 'center' }}>🎰 RODADA DA SORTE!</h1>
      <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 20, textAlign: 'center' }}>Você ganhou uma jogada! Gire e conquiste seu prêmio.</p>
      <div style={{ position: 'relative', marginBottom: 20 }}>
        <div style={{ position: 'absolute', top: -18, left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '12px solid transparent', borderRight: '12px solid transparent', borderTop: '24px solid var(--orange)', zIndex: 10 }} />
        <canvas ref={canvasRef} width={280} height={280} style={{ borderRadius: '50%', border: '4px solid var(--orange)', boxShadow: '0 0 30px rgba(255,107,0,.4)', display: 'block' }} />
      </div>
      {!resultado ? (
        <button onClick={girar} disabled={girando} style={{ background: 'linear-gradient(90deg,var(--red),var(--orange))', border: 'none', color: '#fff', padding: '16px 48px', borderRadius: 30, fontSize: 18, fontWeight: 800, cursor: girando ? 'not-allowed' : 'pointer', opacity: girando ? .6 : 1, fontFamily: 'Nunito,sans-serif' }}>
          {girando ? '🎯 Girando...' : '🎯 GIRAR!'}
        </button>
      ) : (
        <div style={{ width: '100%', maxWidth: 340 }}>
          <div style={{ background: 'linear-gradient(90deg,var(--red),var(--orange))', padding: '16px 20px', borderRadius: '12px 12px 0 0', textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 4 }}>🎉</div>
            <h3 style={{ fontSize: 22, fontWeight: 800, color: '#fff', marginBottom: 4 }}>{resultado.premio?.nome}!</h3>
            <p style={{ fontSize: 13, color: 'rgba(255,255,255,.85)' }}>{resultado.premio?.descricao}</p>
          </div>
          {resultado.cupom_codigo ? (
            <div style={{ background: 'var(--bg2)', border: '2px solid var(--orange)', borderTop: 'none', borderRadius: '0 0 12px 12px', padding: 16 }}>
              <div style={{ background: 'rgba(255,107,0,.1)', border: '1px solid rgba(255,107,0,.3)', borderRadius: 8, padding: '10px 12px', marginBottom: 12, fontSize: 12, color: 'var(--orange)', lineHeight: 1.6 }}>
                ℹ️ Use no campo <strong>"Cupom de desconto"</strong> no próximo pedido. Válido por 7 dias, uso único.
              </div>
              <div style={{ textAlign: 'center', marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 6 }}>SEU CÓDIGO</div>
                <div style={{ background: 'var(--bg4)', border: '2px dashed var(--orange)', borderRadius: 8, padding: '12px 16px', fontFamily: 'monospace', fontSize: 22, fontWeight: 800, color: 'var(--orange)', letterSpacing: 3 }}>{resultado.cupom_codigo}</div>
              </div>
              <button onClick={() => { navigator.clipboard?.writeText(resultado.cupom_codigo); setCopiado(true); }} style={{ width: '100%', background: copiado ? 'rgba(46,168,46,.2)' : 'var(--bg4)', border: `1px solid ${copiado ? '#2ea82e' : 'var(--border)'}`, color: copiado ? '#2ea82e' : 'var(--text)', padding: '10px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontFamily: 'Nunito,sans-serif', fontWeight: 700, marginBottom: 12 }}>
                {copiado ? '✅ Copiado!' : '📋 Copiar código'}
              </button>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 12 }}>
                <div style={{ background: 'var(--bg4)', borderRadius: 8, padding: '8px', textAlign: 'center' }}>
                  <div style={{ fontSize: 10, color: 'var(--text3)' }}>VÁLIDO ATÉ</div>
                  <div style={{ fontSize: 12, fontWeight: 700 }}>{validade.toLocaleDateString('pt-BR')}</div>
                </div>
                <div style={{ background: 'var(--bg4)', borderRadius: 8, padding: '8px', textAlign: 'center' }}>
                  <div style={{ fontSize: 10, color: 'var(--text3)' }}>USOS</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--red)' }}>1x único</div>
                </div>
              </div>
              <button onClick={onFechar} style={{ width: '100%', background: 'linear-gradient(90deg,var(--red),var(--orange))', border: 'none', color: '#fff', padding: '12px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontFamily: 'Nunito,sans-serif', fontWeight: 800 }}>Ver meu pedido →</button>
            </div>
          ) : (
            <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderTop: 'none', borderRadius: '0 0 12px 12px', padding: 16, textAlign: 'center' }}>
              <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 16 }}>Não foi dessa vez! Tente na próxima. 🍀</p>
              <button onClick={onFechar} style={{ width: '100%', background: 'var(--bg3)', border: '1px solid var(--border)', color: 'var(--text)', padding: '12px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>Ver meu pedido →</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ==================== CHECKOUT ====================
export default function Checkout() {
  const { cart, subtotal, clearCart } = useCart();
  const { user, updatePontos } = useAuth();
  const navigate = useNavigate();

  const [etapa, setEtapa] = useState('form'); // form | pix | cartao | aguardando | roleta
  const [pedidoId, setPedidoId] = useState(null);
  const [pixData, setPixData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [copiado, setCopiado] = useState(false);
  const [verificando, setVerificando] = useState(false);
  const intervaloRef = useRef(null);

  // Forma de pagamento
  const [formaPag, setFormaPag] = useState('pix'); // pix | cartao | dinheiro
  const [troco, setTroco] = useState('');
  const [precisaTroco, setPrecisaTroco] = useState(false);

  // Cupom
  const [cupom, setCupom] = useState('');
  const [cupomAplicado, setCupomAplicado] = useState(null);
  const [loadingCupom, setLoadingCupom] = useState(false);
  const [erroCupom, setErroCupom] = useState('');

  // Endereço
  const [endereco, setEndereco] = useState({ rua: '', numero: '', complemento: '', referencia: '' });

  // Taxas de entrega
  const [taxas, setTaxas] = useState([]);
  const [taxaSelecionada, setTaxaSelecionada] = useState(''); // id da taxa OU 'retirada' OU 'fora'
  const [whatsappLoja, setWhatsappLoja] = useState('');

  useEffect(() => {
    api('/api/taxas/publico').then(r => setTaxas(r.data)).catch(() => {});
    api('/api/configuracoes/publico').then(r => setWhatsappLoja(r.data.whatsapp || '')).catch(() => {});
  }, []);

  const taxaInfo = taxas.find(t => String(t.id) === String(taxaSelecionada));
  const retirada = taxaSelecionada === 'retirada';
  const foraDaArea = taxaSelecionada === 'fora';
  const taxa = retirada ? 0 : (taxaInfo ? Number(taxaInfo.valor) : 0);
  const desconto = cupomAplicado?.desconto || 0;
  const total = Math.max(subtotal + taxa - desconto, 0);

  useEffect(() => { if (!cart.length && etapa === 'form') navigate('/carrinho'); }, []);

  // Verificação automática pagamento Pix
  useEffect(() => {
    if (etapa === 'pix' && pedidoId) {
      intervaloRef.current = setInterval(() => verificarPagamento(true), 5000);
    }
    return () => clearInterval(intervaloRef.current);
  }, [etapa, pedidoId]);

  const aplicarCupom = async () => {
    if (!cupom.trim()) return;
    setLoadingCupom(true); setErroCupom('');
    try {
      const r = await api('/api/pedidos/validar-cupom', { method: 'POST', data: { codigo: cupom.trim(), subtotal } });
      setCupomAplicado(r.data);
    } catch (e) {
      setErroCupom(e.response?.data?.error || 'Cupom inválido ou expirado');
      setCupomAplicado(null);
    } finally { setLoadingCupom(false); }
  };

  const fazerPedido = async () => {
    if (foraDaArea) return setErro('Bairro fora da área de entrega. Fale conosco no WhatsApp.');
    if (!taxaSelecionada) return setErro('Selecione o bairro/condomínio ou marque "retirar na loja"');
    if (!retirada && (!endereco.rua || !endereco.numero)) return setErro('Preencha rua e número');
    setLoading(true); setErro('');
    try {
      const local = retirada ? 'RETIRADA NA LOJA' : (taxaInfo?.nome || '');
      const endStr = retirada
        ? 'RETIRADA NA LOJA'
        : [endereco.rua, endereco.numero, local, endereco.complemento, endereco.referencia].filter(Boolean).join(', ');
      const itens = cart.map(i => ({
  produto_id: i.id,
  quantidade: i.qty,
  adicionais: (i.adicionais || []).map(a => ({
  adicional_id: a.id,
  quantidade: a.quantidade || 1
})),
observacao: [
  i.remover?.length ? `Sem: ${i.remover.join(', ')}` : '',
  i.observacao || ''
].filter(Boolean).join(' | ')
}));

      // Observação de pagamento em dinheiro
      const obsPagamento = formaPag === 'dinheiro'
        ? `PAGAMENTO: Dinheiro na entrega${precisaTroco && troco ? ` | Troco para R$ ${troco}` : ' | Sem troco'}` : '';

      const r = await criarPedido({
        itens,
        endereco_entrega: endStr,
        coupon_codigo: cupomAplicado?.codigo,
        observacoes: obsPagamento,
        taxa_id: retirada ? null : Number(taxaSelecionada),
        retirada
      });
      setPedidoId(r.data.pedido_id);

      if (formaPag === 'pix') {
        // Gerar Pix real
        const pix = await api(`/api/pix/gerar/${r.data.pedido_id}`, { method: 'POST' });
        setPixData(pix.data);
        setEtapa('pix');
      } else if (formaPag === 'cartao') {
        setEtapa('cartao');
      } else {
        // Dinheiro — confirmar direto
        await confirmarDinheiro(r.data.pedido_id);
      }
    } catch (e) { setErro(e.response?.data?.error || 'Erro ao criar pedido'); }
    finally { setLoading(false); }
  };

  const confirmarDinheiro = async (id) => {
    try {
      const r = await api(`/api/pedidos/${id}/confirmar-pagamento`, { method: 'POST' });
      clearCart();
      if (user) updatePontos((user.pontos || 0) + (r.data.pontos_ganhos || 0));
      setEtapa('roleta');
    } catch (e) { setErro(e.response?.data?.error || 'Erro'); }
  };

  const verificarPagamento = async (silencioso = false) => {
    if (!pedidoId) return;
    if (!silencioso) setVerificando(true);
    try {
      const r = await api(`/api/pix/status/${pedidoId}`);
      if (r.data.pago) {
        clearInterval(intervaloRef.current);
        clearCart();
        if (user) updatePontos((user.pontos || 0) + (r.data.pontos_ganhos || 0));
        setEtapa('roleta');
      }
    } catch {} finally { if (!silencioso) setVerificando(false); }
  };

  if (etapa === 'roleta') return <Roleta pedidoId={pedidoId} onFechar={() => navigate('/pedidos')} />;

  return (
    <div style={{ padding: 16 }}>
      <h2>💳 Finalizar Pedido</h2>
      {erro && <div style={{ background: 'rgba(230,48,48,.15)', border: '1px solid rgba(230,48,48,.3)', color: 'var(--red)', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>{erro}</div>}

      {/* RESUMO */}
      <div className="card" style={{ marginBottom: 14 }}>
        <h3 style={{ marginBottom: 10 }}>🛒 Resumo</h3>
        {cart.map(item => (
          <div key={item.id} style={{ padding: '6px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span>{item.qty}x {item.nome}</span>
              <span style={{ color: 'var(--orange)', fontWeight: 700 }}>R$ {(item.preco * item.qty).toFixed(2).replace('.', ',')}</span>
            </div>
            {item.adicionais?.length > 0 && <div style={{ fontSize: 11, color: '#2ea82e' }}>➕ {item.adicionais.map(a => `${a.quantidade || 1}x ${a.nome}`).join(', ')}</div>}
            {item.remover?.length > 0 && <div style={{ fontSize: 11, color: 'var(--red)' }}>➖ Sem: {item.remover.join(', ')}</div>}
            {item.observacao && <div style={{ fontSize: 11, color: 'var(--orange)' }}>💬 {item.observacao}</div>}
          </div>
        ))}
        <div style={{ marginTop: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--text2)', marginBottom: 4 }}><span>Subtotal</span><span>R$ {subtotal.toFixed(2).replace('.', ',')}</span></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: 'var(--text2)', marginBottom: 4 }}><span>Taxa de entrega</span><span>R$ {taxa.toFixed(2).replace('.', ',')}</span></div>
          {desconto > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#2ea82e', marginBottom: 4, fontWeight: 700 }}><span>🎟️ Desconto</span><span>- R$ {desconto.toFixed(2).replace('.', ',')}</span></div>}
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 18, fontWeight: 800, borderTop: '1px solid var(--border)', paddingTop: 8, marginTop: 4, color: 'var(--orange)' }}><span>Total</span><span>R$ {total.toFixed(2).replace('.', ',')}</span></div>
          <div style={{ fontSize: 11, color: 'var(--orange)', marginTop: 4 }}>⭐ +{Math.floor(total)} pontos + 🎰 rodada da sorte!</div>
        </div>
      </div>

      {etapa === 'form' && (
        <>
          {/* CUPOM */}
          <div className="card" style={{ marginBottom: 14 }}>
            <h3 style={{ marginBottom: 12 }}>🎟️ Cupom de desconto</h3>
            {!cupomAplicado ? (
              <>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input className="input-field" placeholder="Código do cupom..." value={cupom}
                    onChange={e => setCupom(e.target.value.toUpperCase())}
                    onKeyDown={e => e.key === 'Enter' && aplicarCupom()}
                    style={{ flex: 1, fontFamily: 'monospace', fontWeight: 700, letterSpacing: 1 }} />
                  <button onClick={aplicarCupom} disabled={loadingCupom || !cupom.trim()} style={{ background: 'linear-gradient(90deg,var(--red),var(--orange))', border: 'none', color: '#fff', padding: '0 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontFamily: 'Nunito,sans-serif', fontWeight: 700 }}>
                    {loadingCupom ? '...' : 'Aplicar'}
                  </button>
                </div>
                {erroCupom && <div style={{ fontSize: 12, color: 'var(--red)', marginTop: 6 }}>⚠️ {erroCupom}</div>}
                <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>Ganhou um cupom na roleta? Insira aqui.</div>
              </>
            ) : (
              <div style={{ background: 'rgba(46,168,46,.1)', border: '1px solid rgba(46,168,46,.3)', borderRadius: 8, padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#2ea82e' }}>✅ Cupom aplicado!</div>
                  <div style={{ fontSize: 12, color: 'var(--text2)' }}>{cupomAplicado.codigo} — {cupomAplicado.descricao}</div>
                </div>
                <button onClick={() => { setCupomAplicado(null); setCupom(''); }} style={{ background: 'none', border: 'none', color: 'var(--text3)', cursor: 'pointer', fontSize: 18 }}>✕</button>
              </div>
            )}
          </div>

          {/* FORMA DE PAGAMENTO */}
          <div className="card" style={{ marginBottom: 14 }}>
            <h3 style={{ marginBottom: 14 }}>💳 Forma de pagamento</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                { id: 'pix', icon: '📱', label: 'Pix', desc: 'QR Code — instantâneo' },
                { id: 'cartao', icon: '💳', label: 'Cartão de crédito/débito', desc: 'Pagar com cartão agora' },
                { id: 'dinheiro', icon: '💵', label: 'Dinheiro na entrega', desc: 'Pague ao receber' },
              ].map(op => (
                <div key={op.id} onClick={() => setFormaPag(op.id)} style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px',
                  background: formaPag === op.id ? 'rgba(255,107,0,.1)' : 'var(--bg4)',
                  border: `2px solid ${formaPag === op.id ? 'var(--orange)' : 'var(--border)'}`,
                  borderRadius: 10, cursor: 'pointer', transition: 'all .2s'
                }}>
                  <span style={{ fontSize: 24 }}>{op.icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 14 }}>{op.label}</div>
                    <div style={{ fontSize: 11, color: 'var(--text2)' }}>{op.desc}</div>
                  </div>
                  <div style={{ width: 20, height: 20, borderRadius: '50%', border: `2px solid ${formaPag === op.id ? 'var(--orange)' : 'var(--border)'}`, background: formaPag === op.id ? 'var(--orange)' : 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formaPag === op.id && <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#fff' }} />}
                  </div>
                </div>
              ))}
            </div>

            {/* Troco (dinheiro) */}
            {formaPag === 'dinheiro' && (
              <div style={{ marginTop: 12, padding: 12, background: 'var(--bg4)', borderRadius: 8 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700, marginBottom: 10 }}>
                  <input type="checkbox" checked={precisaTroco} onChange={e => setPrecisaTroco(e.target.checked)} style={{ width: 16, height: 16, accentColor: 'var(--orange)' }} />
                  Preciso de troco
                </label>
                {precisaTroco && (
                  <div className="input-group" style={{ marginBottom: 0 }}>
                    <label className="input-label">Troco para quanto?</label>
                    <input className="input-field" type="number" placeholder={`Ex: ${Math.ceil(total / 10) * 10}.00`} value={troco} onChange={e => setTroco(e.target.value)} />
                    {troco && parseFloat(troco) < total && <div style={{ fontSize: 11, color: 'var(--red)', marginTop: 4 }}>⚠️ Valor menor que o total do pedido</div>}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* BAIRRO / RETIRADA */}
          <div className="card" style={{ marginBottom: 14 }}>
            <h3 style={{ marginBottom: 14 }}>🛵 Como você quer receber?</h3>

            <div className="input-group" style={{ marginBottom: 10 }}>
              <label className="input-label">Bairro / Condomínio *</label>
              <select
                className="input-field"
                value={taxaSelecionada}
                onChange={e => setTaxaSelecionada(e.target.value)}
                style={{ cursor: 'pointer' }}
              >
                <option value="">Selecione...</option>
                <option value="retirada">🏪 Retirar na loja (sem taxa)</option>
                <optgroup label="🏘️ Bairros">
                  {taxas.filter(t => t.tipo === 'bairro').map(t => (
                    <option key={t.id} value={t.id}>
                      {t.nome} — R$ {Number(t.valor).toFixed(2).replace('.', ',')}
                    </option>
                  ))}
                </optgroup>
                <optgroup label="🏢 Condomínios">
                  {taxas.filter(t => t.tipo === 'condominio').map(t => (
                    <option key={t.id} value={t.id}>
                      {t.nome} — R$ {Number(t.valor).toFixed(2).replace('.', ',')}
                    </option>
                  ))}
                </optgroup>
                <option value="fora">❓ Meu bairro não está na lista</option>
              </select>
            </div>

            {/* Bairro fora da área */}
            {foraDaArea && (
              <div style={{
                background: 'rgba(230,48,48,.1)',
                border: '1px solid rgba(230,48,48,.3)',
                borderRadius: 8, padding: 12, marginBottom: 10
              }}>
                <div style={{ fontSize: 13, color: 'var(--red)', marginBottom: 8, fontWeight: 700 }}>
                  ⚠️ Bairro fora da nossa área de entrega
                </div>
                <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 10 }}>
                  Entre em contato pelo WhatsApp pra confirmarmos se conseguimos atender!
                </div>
                {whatsappLoja && (
                  <a
                    href={`https://wa.me/55${whatsappLoja.replace(/\D/g, '')}?text=Ol%C3%A1!%20Meu%20bairro%20n%C3%A3o%20aparece%20na%20lista%2C%20voc%C3%AAs%20entregam%20aqui%3F`}
                    target="_blank" rel="noopener noreferrer"
                    style={{
                      display: 'block', textAlign: 'center',
                      background: '#25D366', color: '#fff',
                      padding: '10px 14px', borderRadius: 8,
                      fontWeight: 800, textDecoration: 'none', fontSize: 13
                    }}
                  >📱 Falar no WhatsApp</a>
                )}
              </div>
            )}

            {/* Taxa selecionada */}
            {taxaInfo && (
              <div style={{
                background: 'rgba(46,168,46,.08)',
                border: '1px solid rgba(46,168,46,.3)',
                borderRadius: 8, padding: 10, marginBottom: 10,
                fontSize: 12, color: '#2ea82e', fontWeight: 700
              }}>
                ✅ Taxa de entrega: R$ {Number(taxaInfo.valor).toFixed(2).replace('.', ',')}
              </div>
            )}

            {/* Retirada na loja */}
            {retirada && (
              <div style={{
                background: 'rgba(255,107,0,.08)',
                border: '1px solid rgba(255,107,0,.3)',
                borderRadius: 8, padding: 12,
                fontSize: 12, color: 'var(--orange)', fontWeight: 700
              }}>
                🏪 Você vai retirar na loja — sem taxa de entrega!
              </div>
            )}
          </div>

          {/* ENDEREÇO (só se NÃO for retirada e tiver bairro selecionado) */}
          {!retirada && !foraDaArea && taxaSelecionada && (
            <div className="card" style={{ marginBottom: 14 }}>
              <h3 style={{ marginBottom: 14 }}>📍 Endereço de Entrega</h3>
              <div className="input-group">
                <label className="input-label">Rua / Avenida *</label>
                <input className="input-field" placeholder="Ex: Rua das Flores" value={endereco.rua} onChange={e => setEndereco(p => ({ ...p, rua: e.target.value }))} />
              </div>
              <div className="input-group">
                <label className="input-label">Número *</label>
                <input className="input-field" placeholder="123" value={endereco.numero} onChange={e => setEndereco(p => ({ ...p, numero: e.target.value }))} />
              </div>
              <div className="input-group">
                <label className="input-label">Complemento</label>
                <input className="input-field" placeholder="Apto, bloco, casa..." value={endereco.complemento} onChange={e => setEndereco(p => ({ ...p, complemento: e.target.value }))} />
              </div>
              <div className="input-group" style={{ marginBottom: 0 }}>
                <label className="input-label">Ponto de referência</label>
                <input className="input-field" placeholder="Próximo ao mercado..." value={endereco.referencia} onChange={e => setEndereco(p => ({ ...p, referencia: e.target.value }))} />
              </div>
            </div>
          )}

          <button className="btn-primary" onClick={fazerPedido} disabled={loading || (precisaTroco && troco && parseFloat(troco) < total)}>
            {loading ? '⏳ Processando...' : formaPag === 'pix' ? '📱 Gerar QR Code Pix' : formaPag === 'cartao' ? '💳 Ir para pagamento com cartão' : '✅ Confirmar pedido'}
          </button>
        </>
      )}

      {/* PIX */}
      {etapa === 'pix' && pixData && (
        <div className="card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>Lanches do Parque</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: 'var(--orange)', marginBottom: 12 }}>R$ {total.toFixed(2).replace('.', ',')}</div>
          {pixData.qr_code_base64 && (
            <img src={`data:image/png;base64,${pixData.qr_code_base64}`} alt="QR Code"
              style={{ width: 200, height: 200, borderRadius: 8, border: '2px solid var(--border)', marginBottom: 12 }} />
          )}
          <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>Ou copie o código:</div>
          <div style={{ background: 'var(--bg4)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 12px', fontSize: 10, color: 'var(--text2)', marginBottom: 10, fontFamily: 'monospace', wordBreak: 'break-all', textAlign: 'left' }}>
            {pixData.qr_code?.substring(0, 80)}...
          </div>
          <button onClick={() => { navigator.clipboard?.writeText(pixData.qr_code); setCopiado(true); setTimeout(() => setCopiado(false), 3000); }}
            style={{ width: '100%', background: copiado ? 'rgba(46,168,46,.2)' : 'var(--bg4)', border: `1px solid ${copiado ? '#2ea82e' : 'var(--border)'}`, color: copiado ? '#2ea82e' : 'var(--text)', padding: '10px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontFamily: 'Nunito,sans-serif', fontWeight: 700, marginBottom: 14 }}>
            {copiado ? '✅ Copiado!' : '📋 Copiar código Pix'}
          </button>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 12, fontSize: 13, color: 'var(--text2)' }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--orange)', animation: 'pulse 1.5s infinite' }} />
            Aguardando pagamento...
          </div>
          <button onClick={() => verificarPagamento(false)} disabled={verificando}
            style={{ width: '100%', background: 'linear-gradient(90deg,#1a7a1a,#2ea82e)', border: 'none', color: '#fff', padding: '12px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontFamily: 'Nunito,sans-serif', fontWeight: 800 }}>
            {verificando ? '⏳ Verificando...' : '✅ Já paguei — verificar'}
          </button>
          <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 8 }}>⏳ Expira em 30 min</div>
          <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:.3}}`}</style>
        </div>
      )}

      {/* CARTÃO — Mercado Pago Brick */}
      {etapa === 'cartao' && (
        <div className="card" style={{ textAlign: 'center' }}>
          <h3 style={{ marginBottom: 16 }}>💳 Pagamento com Cartão</h3>
          <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>Total: <strong style={{ color: 'var(--orange)', fontSize: 20 }}>R$ {total.toFixed(2).replace('.', ',')}</strong></div>
          <div id="cardPaymentBrick_container" style={{ minHeight: 300 }}></div>
          <CartaoBrick pedidoId={pedidoId} total={total} onSucesso={() => { clearCart(); if (user) updatePontos((user.pontos || 0) + Math.floor(total)); setEtapa('roleta'); }} onErro={setErro} />
        </div>
      )}
    </div>
  );
}

// ==================== CARTÃO BRICK ====================
function CartaoBrick({ pedidoId, total, onSucesso, onErro }) {
  const mpRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://sdk.mercadopago.com/js/v2';
    script.onload = () => {
      fetch('/api/pix/mp-public-key').then(r => r.json()).then(({ publicKey }) => {
        const mp = new window.MercadoPago(publicKey, { locale: 'pt-BR' });
        const bricksBuilder = mp.bricks();
        bricksBuilder.create('cardPayment', 'cardPaymentBrick_container', {
          initialization: { amount: parseFloat(total) },
          customization: { paymentMethods: { creditCard: 'all', debitCard: 'all' } },
          callbacks: {
            onReady: () => {},
            onSubmit: async (formData) => {
              try {
                const r = await axios.post('/api/pix/pagar-cartao', { formData, pedido_id: pedidoId }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
                if (r.data.status === 'approved') onSucesso();
                else onErro('Pagamento não aprovado: ' + r.data.status_detail);
              } catch (e) { onErro(e.response?.data?.error || 'Erro no pagamento'); }
            },
            onError: (err) => onErro('Erro: ' + err.message),
          }
        });
      });
    };
    document.body.appendChild(script);
    return () => { try { document.body.removeChild(script); } catch {} };
  }, []);

  return null;
}
